import { RouteObject } from 'react-router-dom';
import { unauthentifiedRoutes } from './unauthentified/unauthentified';
import { memberRoutes } from './member/member';
import { productRoutes } from './product/product';
export const routes: (isLogged: boolean | null | undefined) => RouteObject[] = (
    isLogged: boolean | null | undefined
) => [...unauthentifiedRoutes(isLogged), ...memberRoutes(isLogged), ...productRoutes(isLogged)];
